import NBType from '@netbase/nb-type'
import LogoSettingSchema from './LogoSettingSchema'

/**
 * @typedef {import('./LogoSettingSchema').LogoSetting} LogoSetting
 */

/**
 * @typedef {object} LogoTypeSchema
 * @property {number} createDate
 * @property {string} displayName
 * @property {string} enumName
 * @property {number} id
 * @property {LogoSetting[]} logoSettings
 * @property {number} updateDate
 */
const LogoTypeSchema = NBType.object().shape('LogoTypeSchema', {
  /* @prop */
  createDate: NBType.timestamp(),
  /* @prop */
  displayName: NBType.string(),
  /* @prop */
  enumName: NBType.string(),
  /* @prop */
  id: NBType.number(),
  /* @prop */
  logoSettings: NBType.array().of(LogoSettingSchema),
  /* @prop */
  updateDate: NBType.timestamp()
  /* END */
})
export default LogoTypeSchema
// RESERVE BELOW
